export default "__VITE_ASSET__2d2a2303__"